(function () {
  function mitte(d, r) {
    var b = d.parentElement.getBoundingClientRect();
    return { x: b.left + b.width * parseFloat(d.style.left) / 100 - r.left, y: b.top + b.height * parseFloat(d.style.top) / 100 - r.top };
  }
  function linien(bp) {
    var svg = bp.querySelector('.obp__linien');
    var r = bp.getBoundingClientRect();
    if (!svg || !r.width) return;
    svg.setAttribute('viewBox', '0 0 ' + r.width + ' ' + r.height);
    var h = '';
    var handy = window.matchMedia('(max-width: 1023px)').matches;
    bp.querySelectorAll('.obp__punkt').forEach(function (d) {
      var erster = bp.querySelector('.obp__punkt[data-nr="' + d.dataset.nr + '"]') === d;
      d.classList.toggle('obp__punkt--doppelt', handy && !erster);
    });
    bp.querySelectorAll('.obp__k').forEach(function (k) {
      var n = k.dataset.nr, kr = k.getBoundingClientRect(), links = k.dataset.seite === 'l';
      if (!kr.width) return;
      if (handy) {
        var d0 = bp.querySelector('.obp__punkt[data-nr="' + n + '"]');
        if (!d0) return;
        var p = mitte(d0, r);
        h += '<line data-nr="' + n + '" x1="' + (kr.left + kr.width / 2 - r.left) + '" y1="' + (kr.top - r.top) + '" x2="' + p.x + '" y2="' + p.y + '"/>';
        return;
      }
      var x1 = (links ? kr.right : kr.left) - r.left, y1 = kr.top + kr.height / 2 - r.top;
      var ds = bp.querySelectorAll('.obp__punkt[data-nr="' + n + '"]');
      ds.forEach(function (d) {
        var pm = mitte(d, r), x2 = pm.x, y2 = pm.y;
        if (ds.length === 1 || (links && x2 < r.width / 2) || (!links && x2 > r.width / 2)) {
          h += '<line data-nr="' + n + '" x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>';
        }
      });
    });
    svg.innerHTML = h;
    var g = bp.dataset.obpGewaehlt;
    if (g) svg.querySelectorAll('line[data-nr="' + g + '"]').forEach(function (l) { l.classList.add('an'); });
  }
  function alle() { document.querySelectorAll('[data-obp]').forEach(linien); }
  window.oneBauplanLinien = alle;
  window.oneBauplanStart = function () { start(); };
  function an(bp, n) {
    bp.querySelectorAll('[data-nr]').forEach(function (x) { x.classList.toggle('an', n !== null && x.dataset.nr === n); });
  }
  function start() {
    document.querySelectorAll('[data-obp]').forEach(function (bp) {
      if (bp.dataset.obpBereit) return;
      bp.dataset.obpBereit = '1';
      bp.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-nr]'); an(bp, t ? t.dataset.nr : null); });
      bp.addEventListener('mouseleave', function () { if (!bp.dataset.obpGewaehlt) an(bp, null); });
      bp.addEventListener('click', function (e) {
        var k = e.target.closest('.obp__k');
        if (!k) return;
        var n = bp.dataset.obpGewaehlt === k.dataset.nr ? '' : k.dataset.nr;
        if (n) bp.dataset.obpGewaehlt = n; else delete bp.dataset.obpGewaehlt;
        an(bp, n || null);
        k.setAttribute('aria-pressed', n ? 'true' : 'false');
      });
      bp.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', function () { linien(bp); }); });
      if (window.ResizeObserver) new ResizeObserver(function () { linien(bp); }).observe(bp);
    });
    alle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', alle);
  document.addEventListener('shopify:section:load', start);
})();

(function () {
  if (window.__oneDetailsSprung) return;
  window.__oneDetailsSprung = true;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#technische-daten"]');
    if (!a) return;
    var ziel = document.getElementById('technische-daten');
    if (!ziel) return;
    e.preventDefault();
    var reiter = ziel.querySelector('[data-ec-tab="' + (a.getAttribute('data-ec-ziel') || 'daten') + '"]');
    if (reiter && window.oneDetailWahl) {
      window.oneDetailWahl(reiter, false);
    } else {
      var d = ziel.matches('details') ? ziel : ziel.querySelector('details');
      if (d) d.open = true;
    }
    var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#technische-daten');
  });
})();

(function () {
  if (window.__oneDetailsHersteller) return;
  window.__oneDetailsHersteller = true;
  document.addEventListener('click', function (e) {
    var auf = e.target.closest('[data-oiz-auf]');
    if (auf) {
      var d = auf.closest('.odt').querySelector('[data-oiz-dlg]');
      if (d && d.showModal) d.showModal();
      return;
    }
    var zu = e.target.closest('[data-oiz-zu]');
    if (zu) {
      var dz = zu.closest('dialog');
      if (dz) dz.close();
    }
  });
})();

(function () {
  if (window.__oneDetailReiter) return;
  window.__oneDetailReiter = true;
  function spitze(w) {
    var ec = w.querySelector('.ec--spitze');
    if (!ec) return;
    var a = ec.querySelector('[data-ec-tab][aria-selected="true"]'), i = ec.querySelector('.ec__inhalt');
    if (!a || !i) return;
    var ar = a.getBoundingClientRect(), ir = i.getBoundingClientRect();
    var y = Math.max(16, Math.min(ir.height - 16, ar.top + ar.height / 2 - ir.top));
    var x = Math.max(16, Math.min(ir.width - 16, ar.left + ar.width / 2 - ir.left));
    i.style.setProperty('--spitze', y + 'px');
    i.style.setProperty('--spitze-x', x + 'px');
  }
  function alleSpitzen() { document.querySelectorAll('[data-ec]').forEach(spitze); }
  var spitzeWartet = false;
  function spitzenBald() {
    if (spitzeWartet) return;
    spitzeWartet = true;
    requestAnimationFrame(function () { spitzeWartet = false; alleSpitzen(); });
  }
  window.addEventListener('load', alleSpitzen);
  window.addEventListener('resize', spitzenBald);
  window.addEventListener('scroll', spitzenBald, { passive: true });
  function wahl(r, fokus) {
    var w = r.closest('[data-ec]');
    if (!w) return;
    w.querySelectorAll('[data-ec-tab]').forEach(function (x) {
      var an = x === r;
      x.setAttribute('aria-selected', an ? 'true' : 'false');
      x.tabIndex = an ? 0 : -1;
    });
    zeige(w, r.dataset.ecTab);
    if (fokus) r.focus();
    if (window.oneBauplanLinien) requestAnimationFrame(window.oneBauplanLinien);
    requestAnimationFrame(function () { spitze(w); });
  }
  var schmal = window.matchMedia('(max-width: 1023px)');
  function zeige(w, name) {
    w.querySelectorAll('[data-ec-feld]').forEach(function (f) {
      var an = f.dataset.ecFeld === name;
      f.hidden = !an && schmal.matches;
      f.inert = !an;
      if (an) { f.removeAttribute('data-aus'); f.removeAttribute('aria-hidden'); }
      else { f.setAttribute('data-aus', ''); f.setAttribute('aria-hidden', 'true'); }
    });
  }
  function alleZeigen() {
    spitzenBald();
    document.querySelectorAll('[data-ec]').forEach(function (w) {
      var r = w.querySelector('[data-ec-tab][aria-selected="true"]');
      if (r) zeige(w, r.dataset.ecTab);
    });
    if (window.oneBauplanLinien) requestAnimationFrame(window.oneBauplanLinien);
  }
  if (schmal.addEventListener) schmal.addEventListener('change', alleZeigen);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alleZeigen); else alleZeigen();
  document.addEventListener('shopify:section:load', alleZeigen);
  window.oneDetailWahl = wahl;
  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-ec-tab]');
    if (r) wahl(r, false);
  });
  document.addEventListener('keydown', function (e) {
    var r = e.target.closest('[data-ec-tab]');
    if (!r) return;
    var alle = Array.prototype.slice.call(r.closest('[role="tablist"]').querySelectorAll('[data-ec-tab]'));
    var i = alle.indexOf(r), n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = alle[(i + 1) % alle.length];
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = alle[(i - 1 + alle.length) % alle.length];
    else if (e.key === 'Home') n = alle[0];
    else if (e.key === 'End') n = alle[alle.length - 1];
    if (!n) return;
    e.preventDefault();
    wahl(n, true);
  });
  function aufHash() {
    if (location.hash !== '#technische-daten') return;
    var z = document.getElementById('technische-daten');
    var r = z && z.querySelector('[data-ec-tab="daten"]');
    if (r) wahl(r, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aufHash); else aufHash();
  window.addEventListener('hashchange', aufHash);
})();

(function () {
  if (window.__oneDetailWahl) return;
  window.__oneDetailWahl = true;
  var REIHE = 'FG-H01,FG-H02,FG-H03,FG-A03,FG-A02,FG-A01,FG-PHL,FG-PHR,FG-BPS,FG-BPL,FG-SMB,FG-DMB'.split(',');
  var PUNKTE = {
    "FGA-S0": "links=FG-H01,FG-PHR;FG-H01=50,35;FG-PHR=51,46;FG-BPS=50,92",
    "FGA-S1": "links=FG-H01,FG-PHR;FG-H01=55,23;FG-A01=66,27 64,37;FG-PHR=54,42;FG-BPS=50,92",
    "FGA-D1": "links=FG-H01,FG-A01,FG-PHL;FG-H01=11,30 89,30;FG-A01=24,34 36,42 64,42 76,34;FG-PHL=45,48;FG-PHR=55,48;FG-BPS=50,92",
    "FGA-D2S": "links=FG-H02,FG-A01,FG-PHL;FG-H02=11,28 89,28;FG-A01=24,31 36,39 64,39 76,31;FG-PHL=45,45;FG-PHR=55,45;FG-BPS=50,92",
    "FG-S1": "links=FG-H01,FG-PHR;FG-H01=52,9;FG-A03=64,20;FG-A01=64,38;FG-PHR=54,44;FG-BPS=50,92",
    "FG-D1": "links=FG-H01,FG-A03,FG-PHL;FG-H01=8,18 92,18;FG-A03=19,31 81,31;FG-A01=36,48 64,48;FG-PHL=44,54;FG-PHR=56,54;FG-BPS=50,92",
    "FG-D2S": "links=FG-H02,FG-A03,FG-PHL;FG-H02=8,16 92,16;FG-A03=19,29 81,29;FG-A01=37,47 63,47;FG-PHL=45,52;FG-PHR=55,52;FG-BPS=50,92",
    "FG-T1": "links=FG-H01,FG-A03,FG-PHL;FG-H01=8,19 50,38 92,19;FG-A03=20,32 80,32;FG-A01=36,49 64,49;FG-PHL=45,55;FG-PHR=52,47 55,55;FG-BPS=50,92",
    "FG-T2S": "links=FG-H01,FG-H02,FG-A03,FG-PHL;FG-H01=50,37;FG-H02=8,16 92,16;FG-A03=20,30 80,30;FG-A01=37,47 63,47;FG-PHL=45,52;FG-PHR=52,46 55,52;FG-BPS=50,92",
    "FG-Q1": "links=FG-H01,FG-A03,FG-PHL;FG-H01=8,6 92,6 8,41 92,41;FG-A03=20,15 80,15 20,50 80,50;FG-A01=36,28 64,28 36,63 64,63;FG-PHL=45,32 45,67;FG-PHR=55,32 55,67;FG-BPL=50,96",
    "FG-Q2S": "links=FG-H02,FG-A03,FG-PHL;FG-H02=8,6 92,6 8,41 92,41;FG-A03=20,15 80,15 20,50 80,50;FG-A01=36,28 64,28 36,63 64,63;FG-PHL=45,32 45,67;FG-PHR=55,32 55,67;FG-BPL=50,96",
    "cmb_86xwwu9": "links=FG-H02,FG-A01,FG-PHL;FG-H02=31,29 69,29;FG-PHL=44,44;FG-A01=40,36 60,36;FG-PHR=56,44;FG-BPS=50,91",
    "cmb_eds6wk2": "links=FG-H01;FG-H01=50,18 50,66;FG-PHR=51,27 51,75;FG-BPL=50,93",
    "cmb_5jnqe2t": "links=FG-H01,FG-A01;FG-H01=50,19 55,66;FG-PHR=51,27 54,79;FG-A01=66,69 64,75;FG-BPL=50,93",
    "cmb_h6s7uye": "links=FG-H01,FG-A03;FG-H01=50,18 50,66;FG-PHR=51,27 54,82;FG-A03=64,75;FG-A01=64,78;FG-BPL=50,93",
    "cmb_etnzw4p": "links=FG-H01,FG-A01;FG-H01=55,16 55,64;FG-PHR=54,28 54,76;FG-A01=66,19 64,24 66,67 64,72;FG-BPL=50,93",
    "cmb_hyna3eh": "links=FG-H01,FG-A03;FG-H01=52,9 52,56;FG-PHR=54,35 54,82;FG-A03=64,17 64,65;FG-A01=64,30 64,78;FG-BPL=50,93",
    "cmb_rr6smvq": "links=FG-H01,FG-A01,FG-PHL;FG-H01=50,18 11,66 89,66;FG-PHR=51,27 56,78;FG-PHL=44,78;FG-A01=24,69 36,74 76,69 64,74;FG-BPL=50,93",
    "cmb_ppcv5xx": "links=FG-H01,FG-H02,FG-A01,FG-PHL;FG-H01=50,18;FG-PHR=51,27 56,78;FG-H02=11,66 89,66;FG-PHL=44,78;FG-A01=24,69 36,74 76,69 64,74;FG-BPL=50,93",
    "cmb_h77h26w": "links=FG-H01,FG-A03,FG-PHL;FG-H01=50,18 5,66 95,66;FG-PHR=51,27 56,83;FG-PHL=44,83;FG-A03=17,72 83,72;FG-A01=35,80 65,80;FG-BPL=50,93",
    "cmb_aaha6ff": "links=FG-H01,FG-H02,FG-A03,FG-PHL;FG-H01=50,18;FG-PHR=51,27 56,83;FG-H02=6,66 94,66;FG-PHL=44,83;FG-A03=18,72 83,72;FG-A01=36,80 64,80;FG-BPL=50,93",
    "cmb_f5qh7dw": "links=FG-H01,FG-A03,FG-PHL;FG-H01=52,9 8,57 92,57;FG-PHR=54,35 56,83;FG-A03=64,17 19,66 81,66;FG-A01=64,31 36,78 64,78;FG-PHL=44,83;FG-BPL=50,93",
    "cmb_4zd7vcr": "links=FG-H01,FG-H02,FG-A03,FG-PHL;FG-H01=52,9;FG-PHR=54,36 56,83;FG-A03=64,18 19,66 81,66;FG-A01=64,31 36,78 64,78;FG-H02=8,57 92,57;FG-PHL=44,83;FG-BPL=50,93",
    "cmb_femzxgt": "links=FG-H01,FG-A01,FG-PHL;FG-H01=11,16 89,16 11,64 89,64;FG-PHL=44,27 44,75;FG-A01=24,18 36,24 76,18 64,24 24,66 36,71 76,66 64,71;FG-PHR=56,27 56,75;FG-BPL=50,93",
    "cmb_bdnc8ke": "links=FG-H02,FG-A03,FG-PHL;FG-H02=25,20 77,20 25,61 77,61;FG-PHL=44,39 44,81;FG-A03=36,30 65,30 36,72 65,72;FG-PHR=56,39 56,81;FG-BPL=50,93",
    "cmb_vdxv7y8": "links=FG-H02,FG-A01,FG-PHL;FG-H02=31,42 69,42 31,71 69,71;FG-PHL=44,54 44,83;FG-A01=40,48 60,48 40,77 60,77;FG-PHR=56,54 56,83;FG-BPL=50,93",
    "cmb_9tbbd2s": "links=FG-H01,FG-A01,FG-PHL;FG-H01=50,35 11,50 89,50 50,73;FG-PHR=51,43 56,61 51,81;FG-PHL=44,61;FG-A01=24,52 36,57 76,52 64,57;FG-BPL=50,93",
    "cmb_beumsp5": "links=FG-H01,FG-H02,FG-A01,FG-PHL;FG-H01=50,36 50,73;FG-PHR=51,44 56,62 51,81;FG-H02=11,50 89,50;FG-PHL=44,62;FG-A01=24,53 36,58 76,53 64,58;FG-BPL=50,93",
    "cmb_4273vv8": "links=FG-H01,FG-A03,FG-PHL;FG-H01=50,21 8,36 92,36 50,73;FG-PHR=51,30 56,62 51,81;FG-PHL=44,62;FG-A03=19,45 81,45;FG-A01=36,57 64,57;FG-BPL=50,93",
    "cmb_hr24zvs": "links=FG-H01,FG-H02,FG-A03,FG-PHL;FG-H01=50,15 50,80;FG-PHR=51,23 56,68 51,88;FG-H02=7,47 93,47;FG-PHL=44,68;FG-A03=18,55 82,55;FG-A01=36,65 64,65;FG-BPL=50,93",
    "cmb_9ff49b6": "links=FG-H01,FG-A03,FG-PHL;FG-H01=52,27 8,42 92,42 52,56;FG-PHR=54,54 56,68 54,82;FG-A03=64,36 19,51 81,51 64,65;FG-A01=64,49 36,63 64,63 64,78;FG-PHL=44,68;FG-BPL=50,93"
  };
  function punkteVon(k) {
    var roh = PUNKTE[k.code] || (k.preset ? PUNKTE[String(k.preset).toUpperCase()] : '');
    if (!roh) return null;
    var r = { links: [], orte: {} };
    roh.split(';').forEach(function (e) {
      var kv = e.split('=');
      if (kv[0] === 'links') r.links = kv[1].split(',');
      else r.orte[kv[0]] = kv[1].split(' ').map(function (xy) { return xy.split(','); });
    });
    return r;
  }
  var POS = {
    quad_grid: { left: 'oben_links', right: 'oben_rechts', bottom_left: 'unten_links', bottom_right: 'unten_rechts' },
    triple_pyramid: { top: 'oben', bottom_left: 'unten_links', bottom_right: 'unten_rechts' },
    dual_vertical: { top: 'oben', bottom: 'unten' },
    quad_pyramid: { top: 'oben', left: 'links', right: 'rechts', bottom: 'unten' }
  };
  var POS_STD = { left: 'links', right: 'rechts', center: 'mitte', top: 'oben', bottom: 'unten', bottom_left: 'unten_links', bottom_right: 'unten_rechts' };
  function posName(T, anord, p) {
    var k = (POS[anord] || {})[p] || POS_STD[p] || p;
    return (T.pos || {})[k] || k;
  }
  function spanne(a, einheit) {
    if (!a || a[1] == null) return '';
    return (a[0] == null || a[0] === a[1] ? a[1] : a[0] + '–' + a[1]) + ' ' + einheit;
  }
  function winkel(a) {
    if (!a || a[0] == null || a[1] == null) return '';
    var lo = Number(a[0]), hi = Number(a[1]);
    if (lo === -hi) return '± ' + hi + '°';
    return (hi >= 0 ? '+' : '−') + Math.abs(hi) + '° / ' + (lo >= 0 ? '+' : '−') + Math.abs(lo) + '°';
  }
  var DOC = '<svg class="ec__doc" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8z"/><path d="M14 3v5h5M8.5 13h7M8.5 16.5h5"/></svg>';
  function esc(x) {
    return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function texte(w) {
    if (w.__odtT) return w.__odtT;
    var T = {};
    try { T = JSON.parse(w.querySelector('[data-odt-texte]').textContent); } catch (e) {}
    w.__odtT = T;
    return T;
  }
  function zahl(T, n) { return String(Math.round(n * 10) / 10).replace('.', T.dezimal || ','); }
  function fuell(vorlage, wert) { return String(vorlage || '%s').replace('%s', wert); }
  function von(a) { return a && a.length === 2 && a[0] != null && a[1] != null ? a : null; }

  function weg(el) { if (el.dataset.odtWeg) return; el.dataset.odtWeg = el.style.display || '-'; el.style.display = 'none'; }
  function her(el) { var d = el.dataset.odtWeg; if (!d) return; el.style.display = d === '-' ? '' : d; delete el.dataset.odtWeg; }

  function zuruecksetzen(w) {
    w.querySelectorAll('[data-odt-neu]').forEach(function (el) { el.remove(); });
    w.querySelectorAll('[data-odt-weg]').forEach(her);
    w.querySelectorAll('[data-ec-tab] .ec__bild[data-odt-alt]').forEach(function (b) {
      b.innerHTML = b.__odtAlt; b.className = b.getAttribute('data-odt-alt'); b.removeAttribute('data-odt-alt');
    });
    w.querySelectorAll('.obw__k[data-obw-bed]').forEach(function (k) {
      if (k.__odtWert != null) { k.querySelector('[data-obw-wert]').innerHTML = k.__odtWert; k.__odtWert = null; }
      var z = k.querySelector('[data-obw-zusatz]');
      if (z && z.__odtAlt != null) { z.textContent = z.__odtAlt; z.hidden = z.__odtHidden; z.__odtAlt = null; }
      k.hidden = k.hasAttribute('data-obw-aus');
    });
    var r = w.querySelector('.ec__kacheln');
    if (r && r.__odtSp != null) { r.style.setProperty('--obw-spalten', r.__odtSp); r.__odtSp = null; }
    delete w.dataset.odtWahl;
  }

  function navBild(w, tab, html, klasse) {
    var b = w.querySelector('[data-ec-tab="' + tab + '"] .ec__bild');
    if (!b) return;
    if (!b.hasAttribute('data-odt-alt')) { b.__odtAlt = b.innerHTML; b.setAttribute('data-odt-alt', b.className); }
    b.className = 'ec__bild' + (klasse ? ' ' + klasse : '');
    b.innerHTML = html;
  }

  function paket(w, k) {
    var f = w.querySelector('[data-ec-feld="paket"]');
    if (!f) return;
    var teile = (k.teile || []).slice().sort(function (a, b) {
      var ia = REIHE.indexOf(a.sku), ib = REIHE.indexOf(b.sku);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    var bild = k.preset_bild || '';
    var pk = bild ? punkteVon(k) : null, punkte = '';
    var halb = Math.ceil(teile.length / 2), l = '', r = '', n = 0;
    teile.forEach(function (t, i) {
      n += t.anzahl > 0 ? t.anzahl : 1;
      var links = pk ? pk.links.indexOf(t.sku) >= 0 : i < halb;
      if (pk && pk.orte[t.sku]) pk.orte[t.sku].forEach(function (xy) {
        punkte += '<span class="obp__punkt" data-nr="' + (i + 1) + '" style="left: ' + xy[0] + '%; top: ' + xy[1] + '%;" aria-hidden="true">' + (i + 1) + '</span>';
      });
      var li = '<li class="obp__k" data-nr="' + (i + 1) + '" data-seite="' + (links ? 'l' : 'r') + '">'
        + '<span class="obp__nr" aria-hidden="true">' + (i + 1) + '</span>'
        + '<span class="obp__b">' + (t.bild ? '<img src="' + esc(t.bild) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>'
        + '<span class="obp__name">' + (t.anzahl > 1 ? t.anzahl + '× ' : '') + esc(t.titel) + '</span></li>';
      if (links) l += li; else r += li;
    });
    Array.prototype.forEach.call(f.children, weg);
    var d = document.createElement('div');
    d.className = 'obp' + (punkte ? '' : ' obp--ohne-punkte') + (bild ? '' : ' obp--ohne-bild');
    d.setAttribute('data-obp', ''); d.setAttribute('data-odt-neu', '');
    d.innerHTML = '<svg class="obp__linien" aria-hidden="true"></svg><ul class="obp__spalte">' + l + '</ul>'
      + (bild ? '<div class="obp__bild"><img src="' + esc(bild) + '" alt="" loading="lazy">' + punkte + '</div>' : '')
      + '<ul class="obp__spalte">' + r + '</ul>';
    f.appendChild(d);
    navBild(w, 'paket', bild ? '<img src="' + esc(bild) + '" alt="">' : String(n), bild ? '' : 'ec__bild--zahl');
    if (window.oneBauplanStart) window.oneBauplanStart();
  }

  function werte(T, k) {
    var gr = k.preset_zoll || (k.zoll ? fuell(T.bis, zahl(T, k.zoll) + '″') : '');
    var kgTxt = k.preset_kg ? String(k.preset_kg).replace(/^bis\s*/, '').split('–').pop().trim() : (k.kg_max ? fuell(T.kg, zahl(T, k.kg_max)) : '');
    var kg = kgTxt ? fuell(T.bis, kgTxt.replace('.', T.dezimal || ',')) : '';
    var ti = von(k.tisch_mm) ? k.tisch_mm[0] + '–' + k.tisch_mm[1] + ' mm' : '';
    var zollNav = gr ? (String(gr).match(/(\d+(?:[.,]\d+)?)\D*$/) || [])[1] : '';
    var geb = '', gew = '';
    if (k.preset) {
      geb = k.preset_kg_gebogen && k.preset_kg_gebogen !== k.preset_kg ? String(k.preset_kg_gebogen).replace('.', T.dezimal || ',') : '';
      if (k.preset_gewicht_g) gew = fuell(T.kg, zahl(T, k.preset_gewicht_g / 1000));
    } else {
      var kf = von(k.kg), kgb = k.kg_gebogen && k.kg_gebogen[1] != null ? k.kg_gebogen : null;
      if (kgb && (!kf || Number(kgb[1]) !== Number(kf[1]))) {
        geb = kgb[0] ? zahl(T, kgb[0]) + '–' + fuell(T.kg, zahl(T, kgb[1])) : fuell(T.bis, fuell(T.kg, zahl(T, kgb[1])));
      }
      if (k.gewicht_kg) gew = fuell(T.kg, zahl(T, k.gewicht_kg));
    }
    return { gr: gr, kg: kg, ti: ti, zoll: zollNav ? zollNav + '″' : '', geb: geb, gew: gew };
  }

  function blick(w, k, T, v) {
    var f = w.querySelector('[data-ec-feld="blick"]');
    if (!f) return;
    var okz = f.querySelector('.okz');
    var h = '';
    if (v.gr) h += '<div class="okz__z"><span class="okz__wert">' + esc(v.gr) + '</span><span class="okz__l">' + esc(T.groesse) + '</span></div>';
    if (v.kg) h += '<div class="okz__z"><span class="okz__wert">' + esc(v.kg) + '</span><span class="okz__l">' + esc(T.je_monitor) + '</span></div>';
    if (v.ti) h += '<div class="okz__z"><span class="okz__wert">' + esc(v.ti) + '</span><span class="okz__l">' + esc(T.tischplatte) + '</span></div>';
    var d = document.createElement('div');
    d.className = 'okz'; d.setAttribute('data-odt-neu', ''); d.innerHTML = h;
    if (okz) { weg(okz); okz.parentNode.insertBefore(d, okz); } else f.insertBefore(d, f.firstChild);
    f.querySelectorAll('[data-odt-nur-preset]').forEach(weg);
    var zt = w.querySelector('template[data-odt-zeilen]');
    if (zt && (v.geb || v.gew)) {
      var ul = f.querySelector('.oiz');
      if (!ul) { ul = document.createElement('ul'); ul.className = 'oiz'; ul.setAttribute('data-odt-neu', ''); d.parentNode.insertBefore(ul, d.nextSibling); }
      var vor = ul.querySelector('.oiz__i > .oiz__a');
      vor = vor ? vor.parentNode : null;
      [['gebogen', v.geb], ['gewicht', v.gew]].forEach(function (z) {
        if (!z[1]) return;
        var li = zt.content.querySelector('[data-odt-zeile="' + z[0] + '"]').cloneNode(true);
        li.querySelector('.oiz__w').textContent = z[1];
        li.setAttribute('data-odt-neu', '');
        ul.insertBefore(li, vor);
      });
    }
    if (v.zoll) navBild(w, 'blick', esc(v.zoll), 'ec__bild--zahl');
  }

  function daten(w, k, T, v) {
    var f = w.querySelector('[data-ec-feld="daten"]'), tpl = w.querySelector('template[data-odt-vorlage]');
    if (!f || !tpl) return;
    var frag = tpl.content.cloneNode(true), inh = frag.querySelector('.obw__inhalt');
    function zeile(dt, dd) { return dd ? '<div class="obw__t"><dt>' + esc(dt) + '</dt><dd>' + esc(dd) + '</dd></div>' : ''; }
    var vm = von(k.vesa_mitte_mm);
    var arme = '', aus = k.ausladung_mm || {};
    Object.keys(k.positionen || {}).forEach(function (p) {
      var a = aus[p];
      if (!a || !a.vorne) return;
      var vo = fuell(T.arm_vorne, spanne(a.vorne, 'mm')), se = a.seitlich ? fuell(T.arm_seitlich, spanne(a.seitlich, 'mm')) : '';
      arme += se ? '<div class="obw__t"><dt>' + esc(posName(T, k.anordnung, p)) + ' · ' + esc(vo) + '</dt><dd>' + esc(se) + '</dd></div>'
                 : zeile(posName(T, k.anordnung, p), vo);
    });
    var g = {
      bewegung: zeile(T.neigung, winkel(k.neigung_grad)) + zeile(T.drehen, winkel(k.drehen_grad))
        + (k.federhub_mm ? zeile(T.federarm, fuell(T.bis, k.federhub_mm + ' mm')) : ''),
      hoehe: (vm ? zeile(T.monitorhoehe, vm[0] + '–' + vm[1] + ' mm') : '') + (k.verstellweg_mm ? zeile(T.stange_weg, k.verstellweg_mm + ' mm') : '')
        + (k.stange_mm ? zeile(T.stange, k.stange_mm + ' mm') : ''),
      arme: arme
    };
    frag.querySelectorAll('[data-odt-g]').forEach(function (el) {
      var x = g[el.getAttribute('data-odt-g')];
      if (x) el.querySelector('dl').innerHTML = x; else el.remove();
    });
    var mb = frag.querySelector('[data-odt-massbild]');
    if (k.massbild) { mb.querySelector('img').src = k.massbild; mb.hidden = false; inh.classList.add('obw__inhalt--zeichnung'); }
    else mb.remove();
    inh.setAttribute('data-odt-neu', '');
    Array.prototype.forEach.call(f.children, weg);
    f.appendChild(frag);
    navBild(w, 'daten', k.massbild ? '<img src="' + esc(k.massbild) + '" alt="">' : DOC, '');
  }

  function bewegung(w, k, T) {
    var r = w.querySelector('.ec__kacheln');
    if (!r) return;
    var stange = k.aufbau === 'pole', lang = k.stange === 'extended', vm = von(k.vesa_mitte_mm), n = 0;
    r.querySelectorAll('.obw__k[data-obw-bed]').forEach(function (kc) {
      var bed = kc.getAttribute('data-obw-bed'), q = kc.getAttribute('data-obw-quelle');
      var passt = bed === 'feder' ? !!k.feder : bed === 'stange_standard' ? stange && !lang : bed === 'stange_lang' ? stange && lang : true;
      var wEl = kc.querySelector('[data-obw-wert]'), neu = null;
      if (q === 'federarm') neu = k.federhub_mm ? fuell(T.bis, k.federhub_mm + ' mm') : '';
      else if (q === 'monitorhoehe') neu = vm ? vm[0] + '–' + vm[1] + ' mm' : '';
      if (neu !== null) {
        if (kc.__odtWert == null) kc.__odtWert = wEl.innerHTML;
        wEl.textContent = neu;
      } else {
        var ws = k.wie_seite || {};
        var gilt = q === 'ausladung' ? ws.arme : q === 'verstellweg' ? ws.stange
          : (q === 'neigung' || q === 'schwenken' || q === 'drehen') ? ws.kopf : true;
        if (!gilt || kc.hasAttribute('data-obw-aus')) neu = '';
      }
      var z = kc.querySelector('[data-obw-zusatz]');
      if (z) {
        if (z.__odtAlt == null) { z.__odtAlt = z.textContent; z.__odtHidden = z.hidden; }
        z.textContent = k.stange_mm ? fuell(T.zusatz_stange, k.stange_mm) : '';
        z.hidden = !k.stange_mm;
      }
      var an = passt && (neu === null ? !!wEl.textContent.trim() : !!neu);
      kc.hidden = !an;
      if (an) n++;
    });
    if (r.__odtSp == null) r.__odtSp = r.style.getPropertyValue('--obw-spalten');
    r.style.setProperty('--obw-spalten', Math.max(1, Math.min(3, n)));
  }

  function anordnung(w) {
    var r = w.querySelector('[data-ec-tab="anordnung"]');
    if (!r) return;
    if (r.getAttribute('aria-selected') === 'true' && window.oneDetailWahl) {
      var z = w.querySelector('[data-ec-tab]:not([data-ec-tab="anordnung"])');
      if (z) window.oneDetailWahl(z, false);
    }
    weg(r);
    var f = w.querySelector('[data-ec-feld="anordnung"]');
    if (f) weg(f);
  }

  function anwenden(k) {
    document.querySelectorAll('.odt[data-ec]').forEach(function (w) {
      if (!w.querySelector('[data-odt-texte]')) return;
      zuruecksetzen(w);
      if (k) {
        var T = texte(w), v = werte(T, k);
        w.dataset.odtWahl = k.code || '';
        paket(w, k);
        blick(w, k, T, v);
        bewegung(w, k, T);
        daten(w, k, T, v);
        anordnung(w);
      }
    });
    if (window.oneBauplanLinien) requestAnimationFrame(window.oneBauplanLinien);
  }
  document.addEventListener('3idee:konfig', function (e) { anwenden(e.detail || null); });
  function start() { if (window.oneKonfigAktuell) anwenden(window.oneKonfigAktuell); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

(function () {
  if (window.__oneDetailD) return;
  window.__oneDetailD = true;
  var S_MM = 1.225;
  var KOPF = {
    'one-aufbau-fg-d1.png': { w: 1698, h: 966, o: 103, a: 933, k: [[1560, 164], [124, 168]] },
    'one-aufbau-fg-d2s.png': { w: 1698, h: 966, o: 91, a: 923, k: [[136, 160], [1548, 160]] },
    'one-aufbau-fg-s1.png': { w: 1698, h: 966, o: 14, a: 928, k: [[880, 76]] },
    'one-aufbau-fg-t1.png': { w: 1698, h: 966, o: 110, a: 933, k: [[136, 180], [1548, 180], [844, 364]] },
    'one-aufbau-fg-t2s.png': { w: 1698, h: 966, o: 88, a: 924, k: [[132, 156], [1552, 156], [840, 356]] },
    'one-aufbau-fga-d1.png': { w: 1698, h: 966, o: 225, a: 927, k: [[188, 288], [1500, 292]] },
    'one-aufbau-fga-d2s.png': { w: 1698, h: 966, o: 204, a: 927, k: [[172, 268], [1508, 268]] },
    'one-aufbau-fga-s0.png': { w: 1698, h: 966, o: 276, a: 923, k: [[836, 340]] },
    'one-aufbau-fga-s1.png': { w: 1698, h: 966, o: 156, a: 924, k: [[932, 220]] },
    'one-aufbau-fgf-s1.png': { w: 1698, h: 966, o: 199, a: 905, k: [] },
    'one-aufbau-fgf-s2.png': { w: 1698, h: 966, o: 236, a: 914, k: [[241, 284], [1456, 306]] },
    'one-blick-fgf-s1.png': { w: 1698, h: 966, o: 410, a: 905, k: [[1413, 603]] }
  };
  function lebt(el, feld) {
    for (var e = el; e && e !== feld; e = e.parentElement) if (e.hasAttribute('data-odt-weg') || e.hidden) return false;
    return true;
  }
  function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function bildVon(w) {
    var f = w.querySelector('[data-ec-feld="paket"]');
    if (!f) return '';
    var imgs = f.querySelectorAll('.obp__bild img');
    for (var i = 0; i < imgs.length; i++) if (lebt(imgs[i], f)) {
      var src = imgs[i].currentSrc || imgs[i].src;
      var eigen = f.querySelector('[data-blick-bild]');
      if (eigen && /one-aufbau-fgf-s1\./.test(src)) return eigen.getAttribute('data-blick-bild');
      return src;
    }
    return '';
  }
  function umrisse(src, zoll) {
    var name = String(src).split('?')[0].split('/').pop() || '';
    var info = (window.oneKopfpos || {})[name] || KOPF[name];
    if (!info || !info.k || !info.k.length || !zoll) return '<img class="ecd__img" src="' + esc(src) + '" alt="" loading="lazy">';
    var d = zoll * 25.4, mw = d * 16 / Math.sqrt(337) * S_MM, mh = d * 9 / Math.sqrt(337) * S_MM;
    var rects = info.k.map(function (p) { return [p[0] - mw / 2, p[1] - mh / 2, mw, mh]; });
    rects.forEach(function (a, i) {
      rects.forEach(function (b, j) {
        if (j <= i || Math.abs(a[1] - b[1]) > mh / 2) return;
        var l = a[0] < b[0] ? a : b, r = l === a ? b : a, u = l[0] + l[2] + 5 * S_MM - r[0];
        if (u > 0) { l[0] -= u / 2; r[0] += u / 2; }
      });
    });
    var x0 = 0, y0 = info.o || 0, x1 = info.w, y1 = info.a || info.h;
    rects.forEach(function (r) { x0 = Math.min(x0, r[0]); y0 = Math.min(y0, r[1]); x1 = Math.max(x1, r[0] + r[2]); y1 = Math.max(y1, r[1] + r[3]); });
    x0 -= 12; y0 -= 12; x1 += 12; y1 += 12;
    return '<svg class="ecd__svg" viewBox="' + [x0, y0, x1 - x0, y1 - y0].map(Math.round).join(' ') + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true">'
      + '<image href="' + esc(src) + '" x="0" y="0" width="' + info.w + '" height="' + info.h + '"/>'
      + rects.map(function (r) { return '<rect class="ecd__mon" x="' + Math.round(r[0]) + '" y="' + Math.round(r[1]) + '" width="' + Math.round(r[2]) + '" height="' + Math.round(r[3]) + '" rx="10"/>'; }).join('')
      + '</svg>';
  }
  function blickD(w) {
    var f = w.querySelector('[data-ec-feld="blick"]');
    if (!f) return;
    var alt = f.querySelector(':scope > .ecd'); if (alt) alt.remove();
    var src = bildVon(w);
    if (!src) { f.classList.remove('ec__f--d'); return; }
    var zs = [], fs = [];
    f.querySelectorAll('.okz__z').forEach(function (z) { if (lebt(z, f)) zs.push(z); });
    f.querySelectorAll('.oiz__i').forEach(function (z) { if (lebt(z, f)) fs.push(z); });
    var zoll = 0;
    if (zs[0]) { var m = zs[0].textContent.match(/(\d+(?:[.,]\d+)?)\s*[″"]/g); if (m) zoll = parseFloat(m[m.length - 1].replace(',', '.')); }
    var d = document.createElement('div'); d.className = 'ecd';
    var links = document.createElement('div'); links.className = 'ecd__spalte';
    var rechts = document.createElement('div'); rechts.className = 'ecd__spalte';
    zs.forEach(function (z, i) { var k = z.cloneNode(true); k.classList.add('ecd__karte'); (i < 3 ? links : rechts).appendChild(k); });
    var steck = document.createElement('div'); steck.className = 'ecd__karte ecd__steck';
    var fuss = document.createElement('div'); fuss.className = 'ecd__fuss';
    fs.forEach(function (z) {
      var l = z.querySelector('.oiz__l'), w = z.querySelector('.oiz__w'), a = z.querySelector('.oiz__a');
      if (!l || !w) return;
      if (a) {
        var v = document.createElement('div'); v.className = 'ecd__verweis';
        var s = z.querySelector('.oiz__sym'); if (s) v.appendChild(s.cloneNode(true));
        var ak = a.cloneNode(false); ak.removeAttribute('id'); ak.className = 'ecd__link'; ak.textContent = l.textContent.trim();
        v.appendChild(ak); fuss.appendChild(v); return;
      }
      var r = document.createElement('div'); r.className = 'ecd__zeile';
      var lk = document.createElement('span'); lk.className = 'ecd__zl'; lk.textContent = l.textContent.trim();
      var wk = w.cloneNode(true); wk.className = 'ecd__zw'; wk.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
      r.appendChild(lk); r.appendChild(wk); steck.appendChild(r);
    });
    if (steck.children.length) rechts.appendChild(steck);
    if (fuss.children.length) rechts.appendChild(fuss);
    var mitte = document.createElement('div'); mitte.className = 'ecd__mitte';
    mitte.innerHTML = umrisse(src, zoll);
    d.appendChild(links); d.appendChild(mitte); d.appendChild(rechts);
    f.appendChild(d);
    f.classList.add('ec__f--d');
  }
  function bewegungD(w) {
    var f = w.querySelector('[data-ec-feld="bewegung"]');
    if (!f) return;
    var alt = f.querySelector(':scope > .ecm'); if (alt) alt.remove();
    var ks = [];
    f.querySelectorAll('.obw__k').forEach(function (k) { if (!k.hidden && lebt(k, f)) ks.push(k); });
    if (!ks.length) { f.classList.remove('ec__f--d', 'ec__f--film'); return; }
    var huelle = f.querySelector('[data-obw-film]');
    if (!f.__obwFilm && huelle && window.oneFilm) f.__obwFilm = huelle.querySelector('[data-of]');
    var film = f.__obwFilm || null, karte = {}, kap = [];
    if (film) {
      try { karte = JSON.parse(huelle.getAttribute('data-obw-film')) || {}; } catch (e) { karte = {}; }
      kap = window.oneFilm.kapitel(film) || [];
    }
    var d = document.createElement('div'); d.className = 'ecm' + (film ? ' ecm--film' : '');
    var bild = document.createElement('div'); bild.className = 'ecm__bild';
    var liste = document.createElement('div'); liste.className = 'ecm__liste';
    var buehne = null;
    if (film) { buehne = document.createElement('div'); buehne.className = 'ecm__film'; buehne.appendChild(film); }
    var bilder = ks.map(function (k) { var i = k.querySelector('img'); return i ? (i.currentSrc || i.src) : ''; });
    var bereiche = ks.map(function (k) { var n = karte[k.getAttribute('data-obw-quelle')]; return film && n != null && kap[n] ? kap[n] : null; });
    var akt = 0;
    function waehle(i, spielen) {
      akt = i;
      var r = bereiche[i];
      if (r) {
        if (buehne.parentNode !== bild) { bild.textContent = ''; bild.appendChild(buehne); }
        if (spielen) window.oneFilm.abschnitt(film, r[0], r[1]); else window.oneFilm.bereich(film, r[0], r[1]);
      } else {
        if (film) window.oneFilm.stopp(film);
        bild.innerHTML = bilder[i] ? '<img src="' + esc(bilder[i]) + '" alt="" loading="lazy">' : '';
      }
      liste.querySelectorAll('.ecm__z').forEach(function (z, j) { z.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    }
    ks.forEach(function (k, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ecm__z';
      var wert = k.querySelector('[data-obw-wert]'), tb = k.querySelector('.text-block'), zu = k.querySelector('[data-obw-zusatz]');
      var zt = zu && !zu.hidden ? zu.textContent.trim() : '';
      b.innerHTML = '<span class="ecm__w">' + esc(wert ? wert.textContent.trim() : '') + '</span><span class="ecm__l">'
        + esc(tb ? tb.textContent.trim() : '') + (zt ? ' · ' + esc(zt) : '') + '</span>';
      b.addEventListener('click', function () { waehle(i, true); });
      liste.appendChild(b);
    });
    d.appendChild(bild); d.appendChild(liste);
    f.appendChild(d);
    f.classList.add('ec__f--d');
    f.classList.toggle('ec__f--film', !!film);
    var erst = 0;
    if (film) for (var n = 0; n < bereiche.length; n++) if (bereiche[n]) { erst = n; break; }
    waehle(erst, false);
    if (film && !f.__obwGespielt && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (eintraege) {
        if (!eintraege.some(function (e) { return e.isIntersecting; }) || f.__obwGespielt) return;
        f.__obwGespielt = true;
        io.disconnect();
        if (bereiche[akt]) waehle(akt, true);
      }, { threshold: 0.6 });
      io.observe(bild);
    }
  }
  function alle() { document.querySelectorAll('.odt[data-ec]').forEach(function (w) { blickD(w); bewegungD(w); }); }
  document.addEventListener('3idee:konfig', function () { requestAnimationFrame(alle); });
  document.addEventListener('shopify:section:load', alle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(alle); });
  else requestAnimationFrame(alle);
  window.addEventListener('load', alle);
})();

(function () {
  if (window.__oneAnordnung) return;
  window.__oneAnordnung = true;
  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
  var weich = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var fenster = function (t, frueh) { return Math.max(0, Math.min(1, frueh ? t / .55 : (t - .45) / .55)); };
  function zwischen(a, b, t) {
    var ur = weich(fenster(t, Math.abs(b[4]) > Math.abs(a[4]))), us = weich(fenster(t, b[2] < a[2]));
    return [a[0] + (b[0] - a[0]) * us, a[1] + (b[1] - a[1]) * us, a[2] + (b[2] - a[2]) * us, a[3] + (b[3] - a[3]) * us, a[4] + (b[4] - a[4]) * ur];
  }
  function zeichne(g, m) {
    g.setAttribute('transform', 'translate(' + m[0].toFixed(1) + ' ' + m[1].toFixed(1) + ')' + (m[4] ? ' rotate(' + m[4].toFixed(2) + ')' : ''));
    var r = g.querySelectorAll('rect'), x = -m[2] / 2, y = -m[3] / 2;
    for (var i = 0; i < r.length; i++) {
      var rand = i ? 8.6 : 0;
      r[i].setAttribute('x', (x + rand).toFixed(1));
      r[i].setAttribute('y', (y + rand).toFixed(1));
      r[i].setAttribute('width', (m[2] - 2 * rand).toFixed(1));
      r[i].setAttribute('height', (m[3] - (i ? 30.6 : 0)).toFixed(1));
    }
  }
  function ausweichen(l, mitte) {
    var b = l.map(function (m) {
      var w = Math.abs(m[2] / 2 * Math.cos(m[4] * Math.PI / 180)) + Math.abs(m[3] / 2 * Math.sin(m[4] * Math.PI / 180));
      var h = Math.abs(m[2] / 2 * Math.sin(m[4] * Math.PI / 180)) + Math.abs(m[3] / 2 * Math.cos(m[4] * Math.PI / 180));
      return { m: m, w: w, h: h };
    }).sort(function (a, c) { return a.m[0] - c.m[0]; });
    for (var i = 0; i < b.length; i++) for (var j = i + 1; j < b.length; j++) {
      var a = b[i], c = b[j], dx = c.m[0] - a.m[0], dy = c.m[1] - a.m[1];
      var ux = a.w + c.w + 6.1 - Math.abs(dx), uy = a.h + c.h + 6.1 - Math.abs(dy);
      if (ux <= 0 || uy <= 0) continue;
      if (Math.abs(dx) >= Math.abs(dy)) {
        var da = Math.abs(a.m[0] - mitte), dc = Math.abs(c.m[0] - mitte);
        if (da > dc + 1) a.m[0] -= ux; else if (dc > da + 1) c.m[0] += ux; else { a.m[0] -= ux / 2; c.m[0] += ux / 2; }
      } else if (a.m[1] < c.m[1]) a.m[1] -= uy; else c.m[1] -= uy;
    }
    return l;
  }
  function lage(k, l) {
    var g = k.querySelectorAll('[data-m]');
    for (var i = 0; i < g.length; i++) if (l[i]) zeichne(g[i], l[i]);
  }
  function abspielen(feld) {
    if (feld.__ecaLief) return;
    feld.__ecaLief = true;
    var d;
    try { d = JSON.parse(feld.querySelector('[data-eca-daten]').textContent); } catch (e) { return; }
    var ks = feld.querySelectorAll('.eca__k');
    if (ruhig.matches || ks.length < 2 || !d || d.length !== ks.length) return;
    var mitte = d[0].reduce(function (s, m) { return s + m[0]; }, 0) / d[0].length;
    var fest = [];
    for (var i = 1; i < ks.length; i++) {
      fest[i] = ks[i].hasAttribute('data-eca-fest');
      ks[i].style.transition = 'none';
      ks[i].classList.add('is-wartet', 'is-lauf');
      if (!fest[i]) lage(ks[i], d[i - 1]);
      void ks[i].offsetWidth;
      ks[i].style.transition = '';
    }
    var DAUER = 900, TAKT = 1250, START = 250, t0 = 0;
    function takt(jetzt) {
      if (!t0) t0 = jetzt;
      var t = jetzt - t0, fertig = true;
      for (var n = 1; n < ks.length; n++) {
        var a = START + (n - 1) * TAKT;
        if (t < a) { fertig = false; continue; }
        ks[n].classList.remove('is-wartet');
        if (fest[n]) { ks[n].classList.remove('is-lauf'); continue; }
        var u = Math.min(1, (t - a - 200) / DAUER);
        if (u < 1) fertig = false;
        if (u <= 0) continue;
        if (u >= 1) { lage(ks[n], d[n]); ks[n].classList.remove('is-lauf'); continue; }
        var l = [];
        for (var m = 0; m < d[n].length; m++) l.push(zwischen(d[n - 1][m], d[n][m], u));
        lage(ks[n], ausweichen(l, mitte));
      }
      if (!fertig) requestAnimationFrame(takt);
    }
    requestAnimationFrame(takt);
  }
  function beobachten() {
    document.querySelectorAll('[data-ec-tab="anordnung"]').forEach(function (r) {
      if (r.__ecaBeob) return;
      r.__ecaBeob = true;
      var los = function () {
        if (r.getAttribute('aria-selected') !== 'true') return;
        var w = r.closest('[data-ec]'), f = w && w.querySelector('[data-ec-feld="anordnung"]');
        if (f) requestAnimationFrame(function () { abspielen(f); });
      };
      new MutationObserver(los).observe(r, { attributes: true, attributeFilter: ['aria-selected'] });
      los();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachten); else beobachten();
  document.addEventListener('shopify:section:load', beobachten);
})();
